import * as React from 'react';
import { ButtonBase, ButtonBaseProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CustomIcon, { CustomIconName } from './CustomIcon';

/** Reusable "add / import" affordance — dashed primary border, optional leading icon. */
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 9,
    color: theme.palette.primary.main,
    fontWeight: 600,
    padding: '10px 15px',
    border: `1px dashed ${theme.palette.primary.light}`,
    borderRadius: 9,
    background: '#fff',
    cursor: 'pointer',
    fontFamily: 'Montserrat',
    '&:hover': { background: theme.palette.primary.extraLight, borderStyle: 'solid' }
  }
}));

export interface CustomDashedButtonProps extends ButtonBaseProps {
  icon?: CustomIconName;
  iconSize?: number;
}

const CustomDashedButton: React.FC<CustomDashedButtonProps> = ({
  icon,
  iconSize,
  className,
  children,
  ...props
}) => {
  const classes = useStyles();
  return (
    <ButtonBase className={[classes.root, className].filter(Boolean).join(' ')} {...props}>
      {icon && <CustomIcon name={icon} size={iconSize} />}
      {children}
    </ButtonBase>
  );
};

export default CustomDashedButton;
